import { container } from '@hub-la/fe-container'
import { TelegramVerificationProvider, VerificationDonePage } from '@hub-la/fe-telegram-verification'
import { withRoleplayRedirect } from '../components/roleplay-redirect'

export const TelegramVerificationDoneInit = withRoleplayRedirect(() => {
  return (
    <TelegramVerificationProvider container={container}>
      <VerificationDonePage />
    </TelegramVerificationProvider>
  )
})
